import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import React from 'react';

import PopupForm from '~/src/components/Popups/RequestPopupForm';
import { Loader, Message, Subtitle, Title, Wrapper } from '~/src/components/Popups/styled';

import { useRequest } from './useRequest';

const PopupRequestByCall = ({ isOpen, texts, city, onClose }) => {

    const [{ isError, message, isLoading, success }, doRequest, reset] = useRequest();

    const onSuccess = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.applicationForm,
            action: 'sent application via website form; not approved:short',
        });
    };

    const submit = (name, phone) => {
        doRequest({ phone, name, onSuccess });
    };

    const close = () => {
        reset();
        onClose();
    };

    const title = texts.title || '';
    const subtitle = texts.subtitle || 'Оставьте ваш номер телефона и наш менеджер свяжется с вами';

    return (
        <Wrapper isOpen={isOpen} onClose={close}>
            {
                !success &&
                <>
                    <Title>{title}</Title>
                    <Subtitle>{subtitle}</Subtitle>
                    <PopupForm
                        city={city}
                        {...{ isError, message, isLoading }}
                        onSubmit={(name, phone) => submit(name, phone)}
                    />
                </>
            }
            {isError &&
            <Message error>Извините, что-то пошло не так, попробуйте еще раз или напишите нам в чат</Message>}
            {message && <Message>{message}</Message>}
            {isLoading && <Loader/>}
        </Wrapper>
    );
};

export default PopupRequestByCall;
